export const SAVE_ID_PROOF = 'SAVE_ID_PROOF'
export const SAVE_ID_PROOF_FRONT_SIDE = 'SAVE_ID_PROOF_FRONT_SIDE'
export const SAVE_ID_PROOF_BACK_SIDE = "SAVE_ID_PROOF_BACK_SIDE"
export const RESET_ID_PROOF = 'RESET_ID_PROOF'

export const saveIDProof = (idProof) => ({ type: SAVE_ID_PROOF, idProof })
export const saveIDProofFrontSide = (idProofFrontSide) => ({ type: SAVE_ID_PROOF_FRONT_SIDE, idProofFrontSide })
export const saveIDProofBackSide = (idProofBackSide) => ({ type: SAVE_ID_PROOF_BACK_SIDE, idProofBackSide })
export const resetIdProof = () => ({ type: RESET_ID_PROOF })